import { useRef, useEffect } from 'react'

const usePrevious = <T extends any>(value: T): T => {
  const prevValue = useRef<T>(value)

  useEffect(() => {
    prevValue.current = value
  }, [value])

  return prevValue.current
}

export default usePrevious
